import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { EmployeeSearch } from '../../components';
function CardEmployeeSearch({ employeeChangeHandler, initialEmployee }) {
    useTranslation();
    const [employee, setEmployee] = useState({ value: null, validationText: '' });
    const [loadingEmployee, setLoadingEmployee] = useState(true);
    const [selectionHasChanged, setSelectionHasChanged] = useState(false);
    useEffect(() => {
        setEmployee({ value: initialEmployee, validationText: '' });
        setLoadingEmployee(false);
    }, [initialEmployee]);
    return (_jsx(EmployeeSearch, { id: "username", label: $t('Map Employee'), value: employee.value, style: {
            width: '200px'
        }, helperText: employee.validationText, error: Boolean(employee.validationText), onBlurWithValue: async (event, value) => {
            if (selectionHasChanged) {
                setLoadingEmployee(true);
                await employeeChangeHandler(value);
                setLoadingEmployee(false);
                setSelectionHasChanged(false);
            }
        }, onChange: (_event, value, reason) => {
            if (reason === 'clear' && employee.value !== null) {
                setSelectionHasChanged(true);
                setEmployee({ value: null, validationText: '' });
            }
            else if (reason === 'selectOption' && employee.value !== value) {
                setSelectionHasChanged(true);
                setEmployee({ value, validationText: '' });
            }
        }, disabled: loadingEmployee }));
}
export default CardEmployeeSearch;
